import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { FiArrowLeft } from "react-icons/fi";
import toast from "react-hot-toast";
import "./AdminLogin.css";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { setAuthenticated, setIsAdmin } = useAuth();

  const handleSendOTP = async (e) => {
  e.preventDefault();

  setLoading(true);

  try {
    const res = await fetch("http://localhost:5000/send-otp", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
      }),
    });

    const data = await res.json();

    if (!res.ok) {
      toast.error(data.message);
      setLoading(false);
      return;
    }

    toast.success("OTP sent successfully");

    setOtpSent(true);
  } catch (err) {
    toast.error("Failed to send OTP");
  }

  setLoading(false);
};

  const handleVerifyOTP = async (e) => {
  e.preventDefault();

  setLoading(true);

  try {
    const res = await fetch("http://localhost:5000/verify-otp", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        otp,
      }),
    });

    const data = await res.json();

    if (!res.ok) {
      toast.error(data.message);
      setLoading(false);
      return;
    }

    if (data.authenticated) {
      localStorage.setItem("authenticated", "true");
      localStorage.setItem("isAdmin", "true");

      setAuthenticated(true);
      setIsAdmin(true);

      toast.success("Login Successful");

      navigate("/AdminPortal");
    }
  } catch (err) {
    toast.error("OTP Verification Failed");
  }

  setLoading(false);
};

  useEffect(() => {
    const authStatus = localStorage.getItem("authenticated");
    const adminStatus = localStorage.getItem("isAdmin");

    if (authStatus === "true" && adminStatus === "true") {
      navigate("/AdminPortal");
    }
  }, [navigate]);

  useEffect(() => {
    const handleStorageChange = () => {
      const authStatus = localStorage.getItem("authenticated");
      const adminStatus = localStorage.getItem("isAdmin");

      if (authStatus === "true" && adminStatus === "true") {
        navigate("/AdminPortal");
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [navigate]);

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <>
      <Helmet>
        <title>Admin Login - VALSCO</title>
      </Helmet>

      <main className="admin-login-body">
        <button onClick={handleGoBack} className="top-back-btn">
          <FiArrowLeft /> Back
        </button>

        <div className="admin-login-card light-card">
          <h1 className="login-title">Admin Login</h1>

          <p className="admin-message">
            Enter your admin email to receive a one-time password
          </p>

          <form
            onSubmit={otpSent ? handleVerifyOTP : handleSendOTP}
            className="admin-login-form"
          >
            <div className="input-group">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder=" "
              />
              <label>Email</label>
            </div>

            {otpSent && (
  <div className="input-group">
    <input
      type="text"
      required
      value={otp}
      onChange={(e) => setOtp(e.target.value)}
      placeholder=" "
    />

    <label>OTP</label>
  </div>
)}

            <button
              type="submit"
              className="admin-submit-btn"
            >
              {loading
  ? "Please wait..."
  : otpSent
  ? "Verify OTP"
  : "Send OTP"}
            </button>
          </form>
        </div>
      </main>
    </>
  );
};

export default AdminLogin;